import {FC} from 'react'
import {GuideIcon, GuidePart, GuideStep} from '../core/installGuides'

const ICON_TITLES: Record<GuideIcon, string> = {
  share: 'دکمهٔ اشتراک‌گذاری',
  'add-square': 'نماد افزودن',
  kebab: 'دکمهٔ سه‌نقطهٔ عمودی',
  dots: 'دکمهٔ سه‌نقطه',
  menu: 'دکمهٔ منو',
  install: 'نماد نصب',
}

/** The browser's own buttons, drawn as the user sees them, so the step points at the right one. */
export const InstallGuideIcon: FC<{name: GuideIcon}> = ({name}) => (
  <span className='ia-glyph' role='img' aria-label={ICON_TITLES[name]} title={ICON_TITLES[name]}>
    <svg viewBox='0 0 24 24' aria-hidden='true' focusable='false'>
      {name === 'share' && (
        <g
          fill='none'
          stroke='currentColor'
          strokeWidth='1.8'
          strokeLinecap='round'
          strokeLinejoin='round'
        >
          <path d='M8.5 9.5H7a1.5 1.5 0 0 0-1.5 1.5v8A1.5 1.5 0 0 0 7 20.5h10a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 17 9.5h-1.5' />
          <path d='M12 3.5v10.5M8.75 6.75 12 3.5l3.25 3.25' />
        </g>
      )}
      {name === 'add-square' && (
        <g fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round'>
          <rect x='4' y='4' width='16' height='16' rx='4' />
          <path d='M12 8.5v7M8.5 12h7' />
        </g>
      )}
      {name === 'kebab' && (
        <g fill='currentColor'>
          <circle cx='12' cy='5.5' r='1.9' />
          <circle cx='12' cy='12' r='1.9' />
          <circle cx='12' cy='18.5' r='1.9' />
        </g>
      )}
      {name === 'dots' && (
        <g fill='currentColor'>
          <circle cx='5.5' cy='12' r='1.9' />
          <circle cx='12' cy='12' r='1.9' />
          <circle cx='18.5' cy='12' r='1.9' />
        </g>
      )}
      {name === 'menu' && (
        <path
          d='M4.5 7h15M4.5 12h15M4.5 17h15'
          fill='none'
          stroke='currentColor'
          strokeWidth='1.9'
          strokeLinecap='round'
        />
      )}
      {name === 'install' && (
        <g
          fill='none'
          stroke='currentColor'
          strokeWidth='1.7'
          strokeLinecap='round'
          strokeLinejoin='round'
        >
          <rect x='3' y='4' width='18' height='12.5' rx='2' />
          <path d='M8.5 20h7M12 16.5V20M12 7.25v5.5M9.5 10.25 12 12.75l2.5-2.5' />
        </g>
      )}
    </svg>
  </span>
)

const Part: FC<{part: GuidePart}> = ({part}) => {
  if (typeof part === 'string') return <>{part}</>
  if ('icon' in part) return <InstallGuideIcon name={part.icon} />
  return (
    <>
      <strong className='ia-ui'>
        «<bdi>{part.ui}</bdi>»
      </strong>
      {part.en && (
        <span className='ia-ui-en'>
          {' '}
          {/* One left-to-right piece, brackets included: split over two lines, it reads backwards. */}
          <bdi dir='ltr'>({part.en})</bdi>
        </span>
      )}
    </>
  )
}

export const GuideLine: FC<{step: GuideStep}> = ({step}) => (
  <>
    {step.map((part, index) => (
      <Part key={index} part={part} />
    ))}
  </>
)

export const InstallGuideSteps: FC<{steps: GuideStep[]}> = ({steps}) =>
  steps.length ? (
    <ol className='ia-steps'>
      {steps.map((step, index) => (
        <li key={index} className='ia-step'>
          <span className='ia-step__number' aria-hidden='true'>
            {index + 1}
          </span>
          <span className='ia-step__text'>
            <GuideLine step={step} />
          </span>
        </li>
      ))}
    </ol>
  ) : null
